import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {addDays, addWeeks, startOfWeek} from 'date-fns';
import {es} from 'date-fns/locale';
import {GetDifferentInCalendarDaysPipe} from '../../pipes/get-different-in-calendar-days/get-different-in-calendar-days.pipe';

@Component({
  selector: 'app-date-component',
  templateUrl: './date-component.component.html',
  styleUrls: ['./date-component.component.scss'],
  providers: [GetDifferentInCalendarDaysPipe]
})
export class DateComponent implements OnInit {
  // tslint:disable:no-input-rename
  // tslint:disable:no-output-native
  // tslint:disable:no-redundant-jsdoc

  // Passing the date to the component
  @Input('date') selectedDate: Date;
  @Input() hideIndicatorMonth: boolean;
  @Input() hideIndicatorToday: boolean;
  @Input() disabledPastDays: boolean;
  @Input() showAddAppointment: boolean;
  @Output() select: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() filterDay: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() addAppointment: EventEmitter<boolean> = new EventEmitter<boolean>();
  showingWeek: Date[] = [new Date()];
  es = es;
  constructor(
    private getDifferentCalendarDaysPipe: GetDifferentInCalendarDaysPipe
  ) {
  }

  /**
   * Detecta cuando cambia la propiedad selectedDate
   * @param changes
   */
  // tslint:disable:use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedDate && changes.selectedDate.currentValue !== null) {
      this.showingWeek = this.weekArrayFromMonday();
    }
  }

  ngOnInit(): void {
    if (!this.selectedDate) {
      this.selectedDate = new Date();
    }
    this.showingWeek = this.weekArrayFromMonday();
  }

  weekArrayFromMonday(startDay: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 1): Date[] {
    const weekArray = [];

    // Get the start of the day, indicating it starts on monday
    let dayOfTheWeek = startOfWeek(this.selectedDate, {
      weekStartsOn: startDay,
    });


    weekArray.push(dayOfTheWeek);

    // Passing to nthe next day and adding them to the array
    for (let i = 1; i < 7; i++) {
      dayOfTheWeek = addDays(dayOfTheWeek, 1);
      weekArray.push(dayOfTheWeek);
    }

    return weekArray;
  }

  onSelectedDay(date: Date): void {
    if (!this.disabledPastDays || (this.disabledPastDays && !this.getDifferentCalendarDaysPipe.transform(date))) {
      this.checkChangeYearOrMonth(date);
    }
  }

  onNextWeek(): void {
    const date = addWeeks(this.showingWeek[0], 1);
    this.checkChangeYearOrMonth(date);
    this.showingWeek = this.weekArrayFromMonday();
  }

  onPrevWeek(): void {
    const today = new Date();
    let date = addWeeks(this.showingWeek[0], -1);
    if (date < today && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear() &&
      today.getDate() - date.getDate() < 7) {
      // Poner el día de hoy, getDay - 1 porque aquí el día comienza en lunes, en lugar de domingo
      date = addWeeks(this.showingWeek[today.getDay() > 0 ? (today.getDay() - 1) : 6], -1);
    }
    if (!this.disabledPastDays || (this.disabledPastDays && !this.getDifferentCalendarDaysPipe.transform(date))) {
      this.checkChangeYearOrMonth(date);
      this.showingWeek = this.weekArrayFromMonday();
    }
  }

  today(): void {
    this.selectedDate = new Date();
    this.showingWeek = this.weekArrayFromMonday();
    this.checkChangeYearOrMonth(new Date());
  }

  checkChangeYearOrMonth(date: Date): void {
    const cloneDate = this.selectedDate;
    this.selectedDate = date;
    if (date.getFullYear() !== cloneDate.getFullYear() || date.getMonth() !== cloneDate.getMonth()) {
      this.select.emit(this.selectedDate);
    } else {
      this.filterDay.emit(this.selectedDate);
    }
  }

  onEmitAddAppointment(): void {
    this.addAppointment.emit(true);
  }
}
